import app from '../config/configApp';
import { createI18n } from 'vue-i18n';
import ph from './localization/ph/translation.json';
import en from './localization/en/translation.json';

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en: en,
        ph: ph,
    },
})

app.use(i18n);
